import React, { useContext } from "react"
import tw from "twin.macro"
import { useStaticQuery, graphql } from "gatsby"
import { myContext } from "../context/Provider"

// component imports
import { Button, Container, Footnotes } from "../components/auvelity-ui"
import { pushDatalayerEvent } from "../utils"
import Hero from "../components/hero"
import Layout from "../components/layout"
import Seo from "../components/seo"
import HomeContent from "../components/home-content"
import { handleNavClick } from "../utils"
import go_with_auvelity from "../images/home/go_with_auvelity.png"

const IndexPage = () => {
  const context = useContext(myContext)

  const { bgdesktop, bgmobile, site } = useStaticQuery(graphql`
    query {
      bgdesktop: file(relativePath: { eq: "hero/home-hero-desktop.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            width: 1440
            quality: 100
            formats: [AUTO, WEBP, AVIF]
            placeholder: BLURRED
          )
        }
      }
      bgmobile: file(
        relativePath: { eq: "hero/home-hero-mobile.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 960, quality: 100, placeholder: BLURRED)
        }
      }
      site {
        siteMetadata {
          globalSchema
        }
      }
    }
  `)

  const heroDataHomepage = {
    fingerTabs: true,
    actorPortrayals: true
  }

  return (
    <Layout>
      <Seo
        title="For Major Depressive Disorder (MDD) - AUVELITY (dextromethorphan-bupropion)"
        description="AUVELITY is a treatment for adults with MDD. Learn more about how AUVELITY is thought to work, side effects, and see dosing information. Please see Medication Guide, including Boxed Warning for suicidal thoughts and actions."
        socialTitle="For Major Depressive Disorder (MDD) - AUVELITY (dextromethorphan-bupropion)"
        socialDescription="AUVELITY is a treatment for adults with MDD. Learn more about how AUVELITY is thought to work, side effects, and see dosing information. Please see Medication Guide, including Boxed Warning for suicidal thoughts and actions."
        schema={site.siteMetadata.globalSchema}
      />
      <Hero dataObj={heroDataHomepage} bgImgData={!context.isMobile ? bgdesktop : bgmobile} variant="hero-home">
        <Container>
          <div
            css={[
              tw`w-[100%] mt-[220px] mb-[30px] sm:(w-[100%] min-height[500px]) flex flex-col justify-start md:(w-[100%] p-0) lg:(w-[650px] pt-0 min-height[465px] mt-[180px] mb-[30px]) lg:(mt-0)`,
            ]}
          >
            <div tw="-ml-4 rounded-br-regular antialiased bg-opacity-90 text-white text-left mt-[30px] px-4 py-[10px] text-[1rem] lg:(w-[95%] mt-0 pr-10 pt-[35px] text-[1.375rem] leading-snug)">
              <div tw="uppercase mb-[10px]">
                <h1 tw="text-center font-semibold text-[16px] leading-[22px] lg:(text-[20px] leading-[24px] text-left)">
                  For depression symptom<br />relief that's <span tw="text-yellow font-bold">FAST&nbsp;&amp;&nbsp;LASTS</span>
                </h1>
                <div className="big-text">
                  <img src={go_with_auvelity} alt="Go with Auvelity® logo" className="go-big" />
                </div>
              </div>
              <div tw="text-left text-[15px] leading-[22px] font-semibold lg:(text-[19px] leading-[23px] text-left font-normal max-width[370px])">
                Some people saw depression symptom relief in as early as 1 week vs placebo. On average, significant symptom relief was seen at 6 weeks.*
              </div>
            </div>

            <div tw="w-[100%] flex mt-5 flex-row justify-center lg:(w-full justify-start mt-0 w-[calc(100% + 2rem)])">
              <div tw="lg:mr-[5%]">
                <Button
                  arrow={true}
                  env="white"
                  focus="white"
                  className="gtm-cta-click"
                  href="/about-depression"
                  as="link"
                  onClick={e => handleNavClick(e, "/about-depression")}
                  addClassForGTM="fl-more-cta-homepage"
                  styles={tw`w-full flex items-center justify-between text-[1rem] focus-visible:ring-white lg:(block w-auto)`}
                >
                  Learn what’s possible
                </Button>
              </div>
            </div>
            <div tw="mt-[25px] mb-[30px] text-white">
              <Footnotes shadow>
                Measured on a depression rating scale during a<br />6‑week study of 327 adults with MDD.
              </Footnotes>
            </div>
          </div>
        </Container>
      </Hero>
      <HomeContent />
    </Layout>
  )
}
export default IndexPage
